<p-dialog
  [(visible)]="displayDialog"
  [modal]="true"
  [resizable]="false"
  [draggable]="false"
  [style]="{ width: '45%' }"
  (onHide)="onDialogHide()"
>
  <ng-template #header>
    <div class="mb-2">
      <span class="font-bold text-lg">Check in Kiosk Detail</span>
      <span class="text-sm py-1 px-2 rounded-2xl ml-2 background-green-opacity">KIOSK</span>
    </div>
  </ng-template>

  <!-- Connected Device Status -->
  <div>
    <section class="grid grid-cols-12 gap-5 my-5">
      <div class="lg:col-span-6 col-span-12">
        <span class="font-bold">Def Port:</span>
        <span class="green-chip ml-2">{{ selectedItem()?.defPort }}</span>
      </div>

      <div class="lg:col-span-6 col-span-12">
        <span class="font-bold">Counter Name:</span>
        <span class="green-chip ml-2">{{ selectedItem()?.computerName }}</span>
      </div>

      <div class="lg:col-span-6 col-span-12">
        <span class="font-bold">User Name:</span>
        <span class="green-chip ml-2">{{ selectedItem()?.userName }}</span>
      </div>

      <div class="lg:col-span-6 col-span-12">
        <span class="font-bold">Check In System:</span>
        <span class="green-chip ml-2">{{ selectedItem()?.checkInSystem }}</span>
      </div>

      <div class="lg:col-span-6 col-span-12">
        <span class="font-bold">Electron Version:</span>
        <span class="green-chip ml-2">{{ selectedItem()?.electronVersion }}</span>
      </div>

      <div class="lg:col-span-6 col-span-12">
        <span class="font-bold">Server Ip:</span>
        <span class="green-chip ml-2">{{ selectedItem()?.serverIp }}</span>
      </div>
    </section>

    <section>
      <div class="p-4 text-center title-background">
        <span class="text-base">Connected Device Status</span>
      </div>

      <div class="flex py-4 overflow-x-auto">
        @if (getDeviceStatusList().length > 0) {
          @for (device of getDeviceStatusList(); track $index) {
            <div class="flex flex-col items-center mx-7">
              <div class="text-base text-gray-700 mb-1">
                <span>{{ device.name }}</span>
                <span *ngIf="device.status?.logical && device.status?.logical != 'null'">
                  {{ ' (' + device.status?.logical + ')' }}
                </span>
              </div>
              @if (device.status?.physical === 'Offline') {
                <div class="status-indicator error">
                  <div class="status-dot error"></div>
                </div>
              } @else {
                <div class="status-indicator">
                  <div class="status-dot"></div>
                </div>
              }
            </div>
          }
        } @else {
          <div>No data to display</div>
        }
      </div>
    </section>
  </div>

  <hr />

  <ng-template #statusColumnTemplate let-rowData="rowData">
    <div [class]="rowData.url_status === 'red' ? 'status-indicator error' : 'status-indicator'">
      <div [class]="rowData.url_status === 'red' ? 'status-dot error' : 'status-dot'"></div>
    </div>
  </ng-template>
</p-dialog>
